import { useAuth } from "../../../src/contexts/AuthContext";
import { cn } from "../../lib/utils";
import Logo from "../Logo/Logo";
import { MobileSidebar } from "./mobile-sidebar";
import { UserNav } from "./user-nav";

export default function Header() {
  const { user } = useAuth();

  return (
    <div className="top-0 left-0 right-0 z-20 border-b supports-backdrop-blur:bg-background/60 bg-background/95 backdrop-blur">
      <nav className="flex items-center justify-between px-4 h-14">
        <div className="hidden lg:block">
          <Logo className="p-3" />
        </div>
        <div className={cn("block lg:!hidden")}>
          <MobileSidebar />
        </div>

        <div className="flex items-center gap-2">
          <UserNav
            user={{
              name:
                user && user?.lastName && user?.firstName
                  ? `${user.lastName} ${user.firstName}`
                  : "ADMIN",
              email: user?.email ?? "",
              image: "url_to_image",
            }}
          />
        </div>
      </nav>
    </div>
  );
}
